import React from 'react';
import { Box, HStack, Text } from '@chakra-ui/react';

import { TokenIcon } from '@app/components/TokenIcon';
import { formatNumber } from '@app/helpers/format';
import { useTokenPriceV4 } from '@app/hooks/token/useTokenPriceV4';
import { useVaults } from '@app/hooks/plugins/useVaults';
import { getSymbol } from '@app/helpers/symbol';
import { getCurrencySymbol } from '@app/helpers/currency';
import { Token } from '@app/types/token';
import { useConfig } from '@app/config';
import { getTokensWhitelist } from '@app/constants/tokensWhitelist';
import { useSupportedChain } from '@app/hooks/other/useSupportedChain';
import { base } from 'viem/chains';
import { formatUSD } from '@app/helpers/formatUSD';

export const PendingTokenItemPreview = ({ token }: any) => {
  const { pendingAmount } = token;
  const { data: vaults } = useVaults();
  const config = useConfig();
  const TOKENS_WHITELIST = getTokensWhitelist(config);
  const chainId = useSupportedChain()?.chainId;

  const vaultData = vaults?.find(
    v => v.lpToken.id.toLowerCase() === token.address.toLowerCase()
  );

  const symbol = [
    ...TOKENS_WHITELIST,
    {
      contractAddress:
        chainId === base.id
          ? '0x7B8C5d97c25B65f89817E8046851A32e963fc9cD'
          : '0x4D850FE01F07BEd416558A34dbde88bA60aE19BE',
      symbol: 'xKIM'
    }
    // {
    //   contractAddress: '0xC40D4D88aFC7B03C65391cBfB6F399f464F6aB03',
    //   symbol: null
    // }
  ].find(tk => tk.contractAddress === token.address)?.symbol;

  const token0Symbol = !vaultData
    ? null
    : getSymbol(
        getCurrencySymbol({
          contractAddress: vaultData.token0.id,
          symbol: vaultData.token0.symbol
        } as Token) as string
      );
  const token1Symbol = !vaultData
    ? null
    : getSymbol(
        getCurrencySymbol({
          contractAddress: vaultData.token1.id,
          symbol: vaultData.token1.symbol
        } as Token) as string
      );

  const usdAmount = useTokenPriceV4(token.address, token.pendingAmount);

  const usdAmt = `${formatUSD.format(usdAmount ?? 0)}`;

  if (usdAmt === '$0') return null;

  return (
    <Box
      sx={{
        borderRadius: '8px',
        border: '1px solid',
        borderColor: 'whiteOpacity.6',
        background: 'gray.3',
        padding: '26px 16px',
        width: '100%'
      }}
    >
      <HStack>
        {!token0Symbol || !token1Symbol ? (
          <TokenIcon width="32px" height="32px" symbol={symbol} />
        ) : (
          <HStack gap={0}>
            <TokenIcon symbol={token0Symbol} />
            <TokenIcon
              symbol={token1Symbol}
              sx={{ transform: 'translateX(-6px)' }}
            />
            <Text fontSize="18px" fontWeight={500} lineHeight="26px" ml="0px">
              {token0Symbol}
            </Text>
            <Text fontSize="18px" fontWeight={500} lineHeight="26px">
              -
            </Text>
            <Text fontSize="18px" fontWeight={500} lineHeight="26px" mr={1}>
              {token1Symbol}
            </Text>
          </HStack>
        )}

        <Text fontSize="18px" fontWeight={400} lineHeight="26px" color="gray.4">
          {formatNumber(+pendingAmount, 2, { notation: 'compact' }) ?? 0}{' '}
          {symbol ?? ''} ({usdAmt})
        </Text>
      </HStack>
    </Box>
  );
};
